import { FillableFieldComponent } from "@forms/schema";

export const shouldLabelWrap = (field: FillableFieldComponent, shouldHideLabel: boolean) => field.column_size === "half" && !(!!field.label && !shouldHideLabel);

export const shouldPreserveLabelWhiteSpace = (field: FillableFieldComponent, shouldHideLabel: boolean) => field.column_size === "half" && (!field.label || shouldHideLabel);
